import {
  SLO_LATENCY_P95_BREACH_THRESHOLD,
  SLO_LATENCY_P95_WARNING_THRESHOLD,
  SLO_ERROR_RATE_BREACH_THRESHOLD,
  SLO_ERROR_RATE_WARNING_THRESHOLD,
} from '../_constants/sloThresholds';
import type { SloStatus } from '../_types/enrichedGraphNode';

export const deriveSloStatus = (
  latencyP95: number | undefined,
  errorRatePercent: number | undefined
): SloStatus => {
  if (latencyP95 === undefined || errorRatePercent === undefined) {
    return 'unknown';
  }
  if (
    latencyP95 >= SLO_LATENCY_P95_BREACH_THRESHOLD ||
    errorRatePercent >= SLO_ERROR_RATE_BREACH_THRESHOLD
  ) {
    return 'breach';
  }
  if (
    latencyP95 >= SLO_LATENCY_P95_WARNING_THRESHOLD ||
    errorRatePercent >= SLO_ERROR_RATE_WARNING_THRESHOLD
  ) {
    return 'warning';
  }
  return 'healthy';
};
